// extracted by mini-css-extract-plugin
module.exports = {"overlay":"SendOverlay_overlay__fE8s6","content":"SendOverlay_content__3Fm5d"};